import React, { useState, useEffect } from "react"

import { Row, Col, Input, Switch, Select, Space } from "antd"
import BulletPointTicket from "../welcome/components/BulletPointTick"
import logo_right from "images/shippy/integrations/opencart_right.svg"
import "aos/dist/aos.css"
import { useMediaQuery } from "react-responsive"
import BusinessForm from "../business_pages/components/BusinessForm"
import SuccessModal from "../business_pages/components/SuccessModal"
import PluginModal from "../woocommerce_integration/components/PluginModal"

const bulletPoints = [
  "Platus kurjerių pasirinkimas - išsirinkite ir naudokite tik savo verslui tinkamiausius kurjerius",
  "Patogus užsakymų ir siuntų siuntimo valdymas vienoje OpenCart platformoje",
  "Įskiepis nemokamas – jokių papildomų mokesčių"
]

const IntegrationSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [isFormModalVisible, setIsFormModalVisible] = useState(false)
  const [isPluginModalVisible, setIsPluginModalVisible] = useState(false)
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false)

  return (
    <>
      <Row
        gutter={{ lg: 16 }}
        align="middle"
        style={{
          marginTop: isMobileScreen ? "0px" : "-200px",
        }}
      >
        <Col span={24} lg={{ offset: 2, span: 10 }}>
          <div
            style={{
              width: "100%", display: "flex", justifyContent: "center",
              padding: isMobileScreen ? '15px' : ""
            }}
          >
            <div
              data-aos={isMobileScreen ? "" : "flip-left"}
              style={{
                maxWidth: 600,
              }}
            >
              <div className="section-title" style={{ marginTop: isMobileScreen ? "" : "75px" }}>
                {"OpenCart įskiepis – užsakymų administravimo įrankis tavo el. parduotuvei"}
              </div>
              <h5 style={{
                fontSize: 18,
                color: "#2D3948",
                fontFamily: "Trenda-Bold",
                marginTop: 20,
                marginBottom: 30,
              }}>
                {"Jei tavo el. parduotuvė sukurta naudojantis OpenCart platforma, įsidiek užsakymų administravimo įrankį iš Siųsk24"}
              </h5>

              {bulletPoints.map((point, index) => (
                <div className="section-bullet-point" key={index}>
                  <Space size="small">
                    <BulletPointTicket />
                    <div>{point}</div>
                  </Space>
                </div>
              ))}
              <div className="section-buttons">
                <button className="btn btn-primary-alsendo btn-circle btn-lg" onClick={() => {
                  setIsPluginModalVisible(true)
                }}>
                  {"Konsultuotis dėl OpenCart įskiepio"}
                </button>
              </div>
            </div>
          </div>
        </Col>

        <Col span={24} lg={{ offset: 1, span: 11 }}>
          <div
            style={{
              height: !isMobileScreen && 600,
              marginRight: !isMobileScreen && 30,
              marginTop: isMobileScreen ? 0 : 80,
              paddingTop: isMobileScreen ? 0 : 80,
              textAlign: isMobileScreen ? "center" : "left",
            }}
          >
            <img src={logo_right} style={{ width: "80%", maxHeight: "90%" }} />
          </div>
        </Col>
      </Row>
      {isFormModalVisible && (
        <BusinessForm
          setIsFormModalVisible={setIsFormModalVisible}
          setIsSuccessModalVisible={setIsSuccessModalVisible}
        />
      )}
      {isSuccessModalVisible && (
        <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
      )}
      {isPluginModalVisible && (
        <PluginModal setIsPluginModalVisible={setIsPluginModalVisible} setIsSuccessModalVisible={setIsSuccessModalVisible} pluginName={"OpenCart"} />
      )}
    </>
  )
}

export default IntegrationSection
